module.exports = __webpack_public_path__ + "media/Gif4.06e081fc.mp4";